import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

interface GetLoaFilterType {
  closingMonth: string;
}

export const aboFilterAPI = createApi({
  reducerPath: "aboFilterAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAMCEandEmaraldAM: builder.query<any, GetAMCEandEmaraldAMType>({
      query: ({ code, typeId, affiliateCode }) => ({
        url: `/auth/users/active/application/${code}/permissiongrouptype/${typeId}/affiliate/${affiliateCode}/hatv`,
        method: "GET",
      }),
    }),
    getUplineDiamondEmrald: builder.query<any, GetUplineDiamondEmeraldType>({
      query: ({ uplineName, month }) => ({
        url: `/am/aboassign/filter/${uplineName}/month/${month}`,
        method: "GET",
      }),
    }),
    getOptionMasterFilter: builder.query<any, GetOptionMasterFilterType>({
      query: ({ affiliateCode, filterTypeName }) => ({
        url: `/admin/optionmasters/application/amw/name/${filterTypeName}/affiliate/${affiliateCode}`,
        method: "GET",
      }),
    }),
    getloaFilter: builder.query<any, GetLoaFilterType>({
      query: ({ closingMonth }) => ({
        url: `/am/aboassign/filter/loa/month/${closingMonth}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAMCEandEmaraldAMQuery,
  useGetUplineDiamondEmraldQuery,
  useGetOptionMasterFilterQuery,
  useGetloaFilterQuery
} = aboFilterAPI;
